import { useSelector } from "react-redux";
import ParchaaLogo from "../../../images/parchaa.svg";
import ParchaaHip from "../../../images/parchaaHip.svg";
import Bell from "../../../images/bell.svg";
import { useDispatch } from "react-redux";
import { setActiveNavbarTab } from "../../../redux-store/slice/activeNavbarSlice";
import { clearNotifications } from "../../../redux-store/slice/notificationSlice";
import { useTranslation } from 'react-i18next';
import { useState } from "react";
import UserProfile from "../user-profile/UserProfile";
import { setSelectedUser } from "../../../redux-store/slice/selectedUserSlice";

const PHRAppHeader = () => {
  const { t } = useTranslation();
  const unreadCount = useSelector((state) => state.allNotification.unreadCount);
  const activeNavbar = useSelector((state) => state.activeNavbar);
  const dispatch = useDispatch();
  const [openProfile, setOpenProfile] = useState(false);

  const handleActiveNavbar = (value) => {
    dispatch(setActiveNavbarTab(value));
    dispatch(clearNotifications());
    dispatch(setSelectedUser({}));
  };

  // Get the title based on active navbar
  const getTitle = () => {
    if (activeNavbar === "campaign_management") {
      return t("Campaign Management");
    } else if (activeNavbar === "doctor_information_management") {
      return t("Doctor Information Management");
    } else if (activeNavbar === "hmis_doctor_slot_management") {
      return t("HMIS Doctor Slot Management");
    } else if (activeNavbar === "feature_settings") {
      return t("Feature Settings");
    }
    return "PHR App";
  };

  return (
    <div className="fixed border-b w-full bg-white p-1">
      <div className="flex relative justify-between mx-4 items-center">
        <div className="flex-shrink-0 flex items-center">
          <img src={ParchaaLogo} alt="parcha-logo" />
          <div className="text-primary mx-5">{getTitle()}</div>
        </div>

        <div className="flex items-center gap-5 w-[60%]">
          <div className="w-1/2">
            {/* Search input can be added here if needed */}
          </div>
        </div>
        <div className="flex items-center justify-end">

          <button
            className=" cursor-pointer"
            onClick={() => {
              setOpenProfile((prev) => !prev);
            }}
          >
            <img src={ParchaaHip} alt="ParchaaHip" />
          </button>
        </div>
        <UserProfile
          openProfile={openProfile}
          setOpenProfile={setOpenProfile}
        />
      </div>
    </div>
  );
};

export default PHRAppHeader;
